export default "__VITE_ASSET__D12ti7ZV__"